import { ProjectCategoryType } from "@/__generated__/graphql";

export const colors = {
  mainBg: "#0A0A0A",
  button: "#FF744D",
  navLight: "#FFFFFF",
  navDark: "#1E1E1E",
};

export const colorVariables = {
  background: "--background",
  primary: "--primary",
  secondary: "--secondary",
  primaryForeground: "--primary-foreground",
  secondaryForeground: "--secondary-foreground",
  accentForeground: "--accent-foreground",

  statusPending: "--status-pending",
  statusInProgress: "--status-in-progress",
  statusCompleted: "--status-completed",

  servicePaint: "--service-paint",
  serviceRotoscoping: "--service-rotoscoping",
  serviceCompositing: "--service-compositing",
  service2dTracking: "--service-2d-tracking",
  service3dTracking: "--service-3d-tracking",
  serviceAssets: "--service-assets",
};

export const getProjectIconColor = (category?: string) => {
  switch (category) {
    case ProjectCategoryType.Commercial:
      return "#FF744D";
    case ProjectCategoryType.Tv:
      return "#4CAF50";
    case ProjectCategoryType.Film:
      return "#34C2E5";
    default:
      return "#fcb900";
  }
};
